export const getDefaultReportsState = () => ({
  engagementTypeId: -1,
  isLoading: false,
  areStatsLoading: false,
  isGlobalNewslettersReport: false,
  timezone: "",
  pickerStartDate: "",
  pickerEndDate: "",
  pickerOrderIndex: null,
  pickerChannelType: 0,
  pickerEngagementMessageId: null,
  engagement: null,
  productStats: null,
  recommendationProductStats: null,
  engagementStatisticTypes: null,
  isDev: false,
  pingTimeoutInSeconds: 10,
  isTransactionalEngagement: false,
  headers: [],
  selectedEngagements: [],
  trackerStatistics: null,
  selectedEngagementsStatistics: {},
  engagementsPopularLinks: [],
});
